import service from '../base'
export default {
  save (options) {
    return service.post('/ebermain/mainapi/record/consultation/save', options)
  },
  load (options) {
    return service.post('/ebermain/mainapi/record/consultation/load', options)
  },
  list (options) {
    return service.post('/ebermain/mainapi/record/consultation/list', options)
  },
  saveReply (options) {
    return service.post('/ebermain/mainapi/record/consultationReply/save', options)
  },
  listReply (options) {
    return service.post('/ebermain/mainapi/record/consultationReply/list', options)
  },
  saveParticipator (options) {
    return service.post('/ebermain/mainapi/record/consultationParticipator/save', options)
  },
  listParticipator (options) {
    return service.post('/ebermain/mainapi/record/consultationParticipator/list', options)
  },
  listConsultationParticipatorHost (body) {
    return service.post('/ebermain/mainapi/record/consultationParticipatorHost/list', body)
  },
  findConsultationParticipatorHost (body, pagination) {
    return service.post('/ebermain/mainapi/record/consultationParticipatorHost/find', service.paginationBody(body, pagination))
  }
}
